/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Text, BoxEmptyView } from '@components/atoms'
import { DashboardCard } from '@components/molecules'

import { grey } from '@mui/material/colors'
import { DashboardType } from '@schemas'

interface PropsType {
	dataList: DashboardType[]
	onCardClick?: (data: any) => void
	target?: 'mainHome' | 'menu'
	isStatus?: boolean
}

export const DashboardList = (props: PropsType) => {
	const { dataList, onCardClick } = props

	// variables
	const target: 'mainHome' | 'menu' = props.target ?? 'menu'
	const isStatus: boolean = props.isStatus ?? false

	return (
		<View css={style} className={`dashboardList ${target}`}>
			<View className="dashboardOuterView">
				<View className="dashboardListView">
					{target === 'menu' && (
						<View className="dashboardInnerView">
							<Text
								category="s2"
								className="dashboardCount"
							>{`${dataList.length} 건`}</Text>
						</View>
					)}
					<View className="dashboardContentView">
						{Object.keys(dataList).length === 0 ? (
							<View className="emptyView">
								<BoxEmptyView isGrey={true}>
									<Text hint="500">등록된 내역이 없습니다.</Text>
								</BoxEmptyView>
							</View>
						) : (
							dataList.map(aData => {
								return (
									<DashboardCard
										key={aData.id}
										data={aData}
										onClick={onCardClick}
										target={target}
										isStatus={isStatus}
									/>
								)
							})
						)}
					</View>
				</View>
			</View>
		</View>
	)
}

const style = css({
	width: '100%',
	height: 'calc(100% - 0.3rem)',
	overflow: 'auto',

	'.dashboardOuterView': {
		height: '100%',
		padding: '0.5rem 1rem',
		background: grey[50],
		border: '1px solid',
		borderColor: grey[300],
		borderRadius: '5px',

		'.dashboardListView': {
			height: '100%',
			marginBottom: '1rem',

			'.dashboardInnerView': {
				position: 'relative',
				display: 'flex',
				alignItems: 'center',
				height: '2rem',

				'.dashboardCount': {
					position: 'absolute',
					width: 'fit-content',
					height: 'fit-content',
					top: 0,
					bottom: 0,
					right: 0,
					margin: 'auto',
					color: grey[400],
				},
			},

			'.dashboardContentView': {
				height: 'calc(100% - 2rem)',

				'.emptyView': {
					height: '100%',
					width: '100%',
				},
			},
		},
	},

	'&.mainHome': {
		height: '100%',

		'.dashboardOuterView': {
			display: 'flex',
			flexWrap: 'wrap',
			position: 'relative',
			width: '100%',
			height: '100%',
			padding: '0.5rem',
			background: grey['100'],
			border: '1px solid',
			borderColor: grey[300],
			borderRadius: '5px',
			overflow: 'auto',

			'.dashboardListView': {
				display: 'block',
				width: '100%',
				height: '100%',
				minHeight: 'calc(100vh - 30.7rem)',
				maxHeight: 'calc(100vh - 30.7rem)',
				paddingTop: 0,
				marginBottom: 0,
			},
		},
	},

	'@media (max-width: 900px)': {
		minHeight: '30rem',
		maxHeight: '30rem',

		'.dashboardOuterView': {
			padding: 0,
			background: '#fff',
			border: 0,

			'.dashboardListView': {
				'.dashboardContentView': {
					'.emptyView': {
						minHeight: '10rem',
						marginTop: '10rem',
						width: '100%',
					},
				},
			},
		},
	},
})
